import React from "react"
import useGame from "./stores/useGame"
import './style.css'

export default function Wobble() {

    const touch = useGame((state) => state.touch)

    return  <>
                { touch === 'false' &&  
                <div className="interface-hand"> <div className="hand"></div> </div>
                }
                { touch === 'true' &&  <div></div>}
            </>
  }
